export default {"src":"/_next/static/media/rugby-league.60a6b11e.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};